import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import SplitText from 'gsap/SplitText'
import { mapActions, mapState } from 'pinia'
import matchMediaConfig from 'utils/matchMedia.js'

gsap.registerPlugin(ScrollTrigger, SplitText);
gsap.registerEase("easeInOutCubic", [0.42, 0, 0.27, 0.99]);
gsap.registerEase("easeInOutCubic1", [0.42, 0, 0.58, 1]);

export default {
	data() {
		return {
			resultBlock: null,
			titleBlock: null,
			textBlock: null,
			splitText: null,
			splitTitle: null,
			hasAnimatedTitle: false,
			hasAnimatedText: false,
			animation: null,
			animation2: null,
			blockContent: null,
			isDesktop: true
		}
	},
	methods: {
		...mapActions(usePageAnimationStore, ["setPageEnableScroll"]),
		scrollTo() {
			if (this.isDesktop && this.animation) {
				// this.animation.play();

				const secondBlock = document.querySelector('.animation-section .block:nth-child(2)');
				gsap.to(window, {
					duration: 2,
					scrollTo: { y: secondBlock, offsetY: 0 },
					ease: "easeInOutCubic"
				});
			}
			if (!this.isDesktop && this.animation && this.animation2) {

				const secondBlock = document.querySelector('.animation-section .results');
				gsap.to(window, {
					duration: 1,
					scrollTo: { y: secondBlock, offsetY: 0 },
					ease: "easeInOutCubic",
				});
			}
		},
		animateTitle() {
			if (this.hasAnimatedTitle) {
				return;
			}

			if (this.splitTitle) {
				this.splitTitle.revert();
			}

			gsap.set(this.titleBlock, { opacity: 1 });

			this.splitTitle = new SplitText(this.titleBlock, {
				type: "lines",
				linesClass: "line",
				autoSplit: true,
			})

			gsap.from(this.splitTitle.lines, {
				duration: 0.6,
				yPercent: 100,
				opacity: 0,
				stagger: 0.1,
				ease: "linear",
				onComplete: () => {
					this.hasAnimatedTitle = true;
					this.animateText();
				}
			})
		},
		animateText() {
			if (this.hasAnimatedText) return;

			if (this.splitText) {
				this.splitText.revert();
			}
			gsap.set(this.textBlock, { opacity: 1 });

			this.splitText = new SplitText(this.textBlock, {
				type: "lines",
				linesClass: "line",
				autoSplit: true,
			})
			gsap.from(this.splitText.lines, {
				duration: 0.6,
				yPercent: 100,
				opacity: 0,
				stagger: 0.1,
				ease: "linear",
				onComplete: () => {
					this.hasAnimatedText = true;
					// this.setPageEnableScroll(true);
					// this.animation.resume();
				}
			})
		},
		initAnimations() {
			const mm = gsap.matchMedia()
			mm.add(matchMediaConfig, (context) => {
				const { isDesktop, isMobile } = context.conditions

				this.isDesktop = isDesktop;
				context.add(() => {
					const blocks = document.querySelectorAll('.animation-section .block');
					var timeline = gsap.timeline();
					var timeline2 = gsap.timeline();
					let blockHeight = blocks[0].offsetHeight;

					this.blockContent = blocks[0].querySelector('.hero__wrapper');
					const resultsBlock = document.querySelector('.results');
					this.resultBlock = document.querySelector('.results__block--title');
					this.titleBlock = document.querySelector('.results__title');
					this.textBlock = document.querySelector('.results__text');
					const cardsBlock = document.querySelector('.results__block--cards');
					let cardsBlockHeight = cardsBlock.offsetHeight;

					gsap.set(this.titleBlock, { opacity: 0 });
					gsap.set(this.textBlock, { opacity: 0 });
					gsap.set(cardsBlock, { opacity: 1, yPercent: 110 });
					gsap.set(this.blockContent, { opacity: 1 });

					let self = this;

					if (isDesktop) {
						gsap.set('.animation-section .blocks', {
							width: '100%',
							height: '100vh',
							position: 'relative',
						});

						gsap.set('.animation-section .block', {
							position: 'absolute',
							width: '100%',
							height: '100%',
						});
						blocks.forEach((block, index) => {
							if (index === 1) {
								gsap.set(block, { y: index * blockHeight });
								timeline
									.to(blocks[index - 1], {
										y: -180,
										duration: 1,
										ease: "easeInOutCubic1"
									}, 0.2)

								timeline.to(this.blockContent, {
									opacity: 0,
									duration: 1,
									ease: "easeInOutCubic1"
								}, 0.2)

								timeline.to(block, {
									y: 0,
									duration: 4,
									ease: "easeInOutCubic"
								}, 0.3)

								timeline.to(resultsBlock, {
									borderRadius: "0px",
									duration: 4,
									ease: "none"
								}, 0.5)

								timeline.to(cardsBlock, {
									opacity: 1,
									yPercent: -10,
									duration: 6,
									ease: "linear"
								}, ">")

							}
						});

						ScrollTrigger.create({
							id: "block1-scrub",
							trigger: ".animation-section",
							start: "top top",
							pin: true,
							end: () => {
								return `+=${blocks.length * blockHeight - cardsBlockHeight}`;
							},
							scrub: true,
							animation: timeline,
							// invalidateOnRefresh: true,
						});

						timeline.to(this.resultBlock, {
							scrollTrigger: {
								id: "result-scrub",
								trigger: this.titleBlock,
								start: "top bottom",
								scrub: true,
								// invalidateOnRefresh: true,
							},
							onStart: function () {
								if (self.hasAnimatedTitle) return;
								self.animateTitle();
							}
						});

						this.animation = timeline;
					}

					if (isMobile) {
						ScrollTrigger.create({
							id: "block1-scrub",
							trigger: '.animation-section',
							start: "top -10%",
							end: "top -20%",
							scrub: true,
							animation: timeline,
						});

						timeline.to(this.blockContent, {
							opacity: 0,
							duration: 1,
							ease: "easeInOutCubic1"
						})

						ScrollTrigger.create({
							id: "block1-scrub",
							trigger: blocks[1],
							start: "top top+=1",
							pin: true,
							end: () => {
								return `+=${blockHeight + cardsBlockHeight}`;
							},
							scrub: true,
							animation: timeline2,
						});

						timeline2.to(this.resultBlock, {
							onStart: function () {
								if (self.hasAnimatedTitle) return;
								self.animateTitle();
							}
						});

						timeline2.to(cardsBlock, {
							opacity: 1,
							yPercent: 0,
							duration: 6,
							ease: "linear"
						}, ">")

						this.animation = timeline;
						this.animation2 = timeline2;
					}
				})
			})
		},
		killAnimations() {
			if (this.splitText) {
				this.splitText.revert();
			}

			if (this.splitTitle) {
				this.splitTitle.revert();
			}

			if (this.animation) {
				this.animation.kill();
				this.animation = null;
			}

			if (this.animation2) {
				this.animation2.kill();
				this.animation2 = null;
			}

			ScrollTrigger.getAll().forEach(trigger => trigger.kill());
		},
	},
	computed: {
		...mapState(usePageAnimationStore, ["getPageCanAnimateBlocks"]),
	},
	mounted() {
		this.$nextTick(() => {
			if (this.getPageCanAnimateBlocks) {
				this.initAnimations();
			}
		});
	},
	beforeUnmount() {
		this.killAnimations();
	},
	watch: {
		getPageCanAnimateBlocks(state) {
			if (state) {
				this.initAnimations();
			}
		},
	}
}
